<template>
	<div class="content__box">
		<div class="banner__box"></div>
		<div class="content__article">
			<div class="content__article-item">
				<h3><span>科睿是谁</span></h3>
				<div>
					<p>
						科睿创立于1987年，是全球领先的ICT（信息与通信）基础设施和智能终端提供商，我们致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界。目前华为约有19.7万员工，业务遍及170多个国家和地区，服务全球30多亿人口。
					</p>
					<p>
						科睿致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界：让无处不在的联接，成为人人平等的权利，成为智能世界的前提和基础；为世界提供最强算力，让云无处不在，让智能无所不及；所有的行业和组织，因强大的数字平台而变得敏捷、高效、生机勃勃；通过AI重新定义体验，让消费者在家居、出行、办公、影音娱乐、运动健康等全场景获得极致的个性化智慧体验。
					</p>
				</div>
			</div>
			<div class="content__article-item">
				<h3><span>科睿是谁</span></h3>
				<div>
					<p>
						科睿创立于1987年，是全球领先的ICT（信息与通信）基础设施和智能终端提供商，我们致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界。目前华为约有19.7万员工，业务遍及170多个国家和地区，服务全球30多亿人口。
					</p>
					<p>
						科睿致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界：让无处不在的联接，成为人人平等的权利，成为智能世界的前提和基础；为世界提供最强算力，让云无处不在，让智能无所不及；所有的行业和组织，因强大的数字平台而变得敏捷、高效、生机勃勃；通过AI重新定义体验，让消费者在家居、出行、办公、影音娱乐、运动健康等全场景获得极致的个性化智慧体验。
					</p>
				</div>
			</div>
			<div class="content__article-item">
				<h3><span>科睿是谁</span></h3>
				<div>
					<p>
						科睿创立于1987年，是全球领先的ICT（信息与通信）基础设施和智能终端提供商，我们致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界。目前华为约有19.7万员工，业务遍及170多个国家和地区，服务全球30多亿人口。
					</p>
					<p>
						科睿致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界：让无处不在的联接，成为人人平等的权利，成为智能世界的前提和基础；为世界提供最强算力，让云无处不在，让智能无所不及；所有的行业和组织，因强大的数字平台而变得敏捷、高效、生机勃勃；通过AI重新定义体验，让消费者在家居、出行、办公、影音娱乐、运动健康等全场景获得极致的个性化智慧体验。
					</p>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
import Footer from "@/views/Footer";
export default {
	components: {
		Footer
	},
	name: "About"
};
</script>

<style lang="less" scoped>
.content__box {
	height: 100%;
	overflow: auto;
}
.banner__box {
	background: url(https://www-file.huawei.com/-/media/corp2020/abouthuawei/corporate-information/corp-info-banner.jpg)
		no-repeat;
	background-size: cover;
	// max-height: 590px;
	background-position: center center;
	min-height: 500px;
	width: 100%;
}

.content__article {
	width: 1200px;
	margin: auto;
	padding: 20px 0;
	.content__article-item {
		display: flex;
		justify-content: space-between;
		h3 {
			width: 200px;
			font-weight: 900;
			font-size: 30px;
			span {
				position: relative;
				padding-left: 10px;
				line-height: 30px;
			}
			span::before {
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				content: "";
				width: 5px;
				height: 30px;
				background: #761a21;
			}
		}
		& > div {
			flex: 1;
			p {
				line-height: 30px;
			}
		}
	}
	.content__article-item + .content__article-item {
		padding-top: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue